export const SOCIAL_MEDIA_BRIEF_AGENT_ID = 'social-media-brief';
